var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4684 17.1379H2.33063V14.0402C2.33063 13.5289 2.60291 13.1379 2.95897 13.1379H15.8401C16.1961 13.1379 16.4684 13.5289 16.4684 14.0402V17.1379Z",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8995 13.1379H2.89954V9.81587C2.89954 9.43169 3.18405 9.13791 3.5561 9.13791H15.243C15.615 9.13791 15.8995 9.43169 15.8995 9.81587V13.1379Z",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9867 17.1379V18.2445",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79141 17.1379V18.2445",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6693 17.1379H17.9069V13.9288C17.9069 13.796 17.9954 13.7075 18.1282 13.7075H21.448C21.5808 13.7075 21.6693 13.796 21.6693 13.9288V17.1379Z",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9169 12.2689H18.6373L18.8586 10.7639C18.8807 10.6533 18.9692 10.5647 19.0799 10.5647H20.4742C20.5849 10.5647 20.6734 10.6533 20.6955 10.7639L20.9169 12.2689Z",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1603 17.1379V18.2445",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3938 17.1379V18.2445",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7881 12.269V13.6411",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84446 13.138H4.06903V11.5941C4.06903 11.3485 4.1947 11.138 4.34131 11.138H8.59312C8.73974 11.138 8.86541 11.3485 8.86541 11.5941V13.138H8.84446Z",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6253 13.138H9.84982V11.5941C9.84982 11.3485 9.97549 11.138 10.1221 11.138H14.3739C14.5205 11.138 14.6462 11.3485 14.6462 11.5941V13.138H14.6253Z",
    stroke: "var(--icon-color,var(--color-text,#363636))",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.e7c7d5f8364dbd360527d6a1a84622d0.svg";
export { ForwardRef as ReactComponent };